// Copyright Epic Games, Inc. All Rights Reserved.

import React from "react";
import { styled, Typography } from "@material-ui/core";
import { useErrorCodeTitle, useIsRTL } from "../../../store/localization/hooks";

const ErrorTitleInternal = styled(Typography)(({ theme }) => ({
  paddingBottom: "6px",
  fontWeight: "bold",
  color: theme.palette.error.light,
}));

export interface IErrorTitleProps {
  errorCode: string;
}

export function ErrorTitle({ errorCode }: IErrorTitleProps): JSX.Element {
  const title = useErrorCodeTitle(errorCode);
  const isRTL = useIsRTL();

  return (
    <ErrorTitleInternal
      variant="body1"
      style={{
        width: "290px",
        textAlign: isRTL ? "center" : "left",
      }}
    >
      {title}
    </ErrorTitleInternal>
  );
}
